export const systemPrompt = ``;

export enum Languages {
  English = "English",
  Spanish = "Spanish",
  Chinese = "Chinese",
  Hindi = "Hindi",
  Arabic = "Arabic",
  Portuguese = "Portuguese",
  Russian = "Russian",
  Japanese = "Japanese",
  German = "German",
  Javanese = "Javanese",
  Korean = "Korean",
  French = "French",
  Turkish = "Turkish",
  Vietnamese = "Vietnamese",
  Italian = "Italian",
  Polish = "Polish",
  Ukrainian = "Ukrainian",
  Romanian = "Romanian",
  Dutch = "Dutch",
  Greek = "Greek",
  Czech = "Czech",
  Swedish = "Swedish",
  Hungarian = "Hungarian",
  Hebrew = "Hebrew",
  Thai = "Thai",
  Burmese = "Burmese",
  Finnish = "Finnish",
  Danish = "Danish",
  Norwegian = "Norwegian",
  Swahili = "Swahili",
  Malay = "Malay",
  Nepali = "Nepali",
  Sinhala = "Sinhala",
  Serbian = "Serbian",
  Bulgarian = "Bulgarian",
  Croatian = "Croatian",
  Albanian = "Albanian",
  Lithuanian = "Lithuanian",
  Latvian = "Latvian",
  Estonian = "Estonian",
  Kazakh = "Kazakh",
  Tagalog = "Tagalog",
  Azerbaijani = "Azerbaijani",
  Slovak = "Slovak",
  Slovene = "Slovene",
  Armenian = "Armenian",
}
